export default __webpack_public_path__ + "static/media/rose.006d519a.png";